import { LeadStage, ResponseStage } from '@prisma/client';
import { Badge } from '@/code/frontend/components/ui/badge';
import { cn } from '@/code/lib/utils/cn';

// Lead stage display names
export const LEAD_STAGE_LABELS: Record<LeadStage, string> = {
  HIDDEN_FROM_USER: 'Hidden',
  UNAPPROVED: 'Unapproved',
  APPROVED: 'Approved',
  QUEUED: 'Queued',
  REQUEST_SENT: 'Request Sent',
  CONNECTED: 'Connected',
  REPLIED: 'Replied',
  CALL_BOOKED: 'Call Booked',
  COMPLETED_CALL: 'Completed Call',
  EXITED: 'Exited',
};

// Response stage display names
export const RESPONSE_STAGE_LABELS: Record<ResponseStage, string> = {
  DRIP: 'Drip',
  IN_PROGRESS: 'In Progress',
  DEFERRED: 'Deferred',
  INTERESTED: 'Interested',
  TO_EXIT: 'To Exit',
  EXITED: 'Exited',
  GHOSTED: 'Ghosted',
  NO_RESPONSE_NEEDED_OR_HUMAN_FLAG: 'No Response Needed',
  NO_RESPONSE_NEEDED: 'No Response Needed',
  HUMAN_FLAG: 'Human Flag',
  AWAITING_USER_FEEDBACK: 'Awaiting User Feedback',
};

interface StageBadgeProps {
  stage: string;
  type: 'lead' | 'response';
}

export function StageBadge({ stage, type }: StageBadgeProps) {
  const label =
    type === 'lead'
      ? LEAD_STAGE_LABELS[stage as LeadStage]
      : RESPONSE_STAGE_LABELS[stage as ResponseStage];

  const colorClasses =
    type === 'lead'
      ? 'bg-blue-100 text-blue-800 border-blue-200'
      : 'bg-purple-100 text-purple-800 border-purple-200';

  return (
    <Badge
      variant="outline"
      className={cn('px-2 py-0.5 text-xs font-medium', colorClasses)}
    >
      {label}
    </Badge>
  );
}
